module.exports = __webpack_public_path__ + "static/img/userid.5d8d0d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/userid.png
// module id = Nb3u
// module chunks = 5